const FooterListHeader = ({ header }) => (
    <li>
        <h6>{header}</h6>
    </li>
)

FooterListHeader.propTypes = {
    header: PropTypes.string.isRequired,
}

export default FooterListHeader
